import axios from "axios";
import {
  buildAuthHeaders,
  getCallCenterBaseUrl,
  requestCallCenter,
  unwrapEnvelopeValue,
} from "./CallCenterApi";

const CC_ORG_LIST_MAX_SIZE = 200;

/**
 * @param {object} [params]
 * @param {number} [params.page]
 * @param {number} [params.size]
 * @param {'CODE'|'NAME'|'CREATED_AT'} [params.sortBy]
 * @param {'ASC'|'DESC'} [params.sortDir]
 * @param {boolean} [params.includeInactive]
 * @param {string} [params.q]
 */
export const listOrganizations = async (params = {}) => {
  const {
    page = 0,
    size = 20,
    sortBy = "CODE",
    sortDir = "ASC",
    includeInactive = false,
    q = "",
  } = params;
  const safeSize = Math.min(
    CC_ORG_LIST_MAX_SIZE,
    Math.max(1, Number.isFinite(Number(size)) ? Number(size) : 20)
  );
  const safePage = Math.max(0, Number.isFinite(Number(page)) ? Number(page) : 0);
  const envelope = await requestCallCenter({
    method: "GET",
    url: "admin/organizations",
    params: {
      page: safePage,
      size: safeSize,
      sortBy,
      sortDir,
      includeInactive,
      ...(q?.trim() ? { q: q.trim() } : {}),
    },
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {string|number} organizationId
 */
export const getOrganization = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "GET",
    url: `admin/organizations/${organizationId}`,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {{ code: string, name: string }} body
 */
export const createOrganization = async (body) => {
  const envelope = await requestCallCenter({
    method: "POST",
    url: "admin/organizations",
    data: body,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {string|number} organizationId
 * @param {{ name?: string, active?: boolean }} body
 */
export const updateOrganization = async (organizationId, body) => {
  const envelope = await requestCallCenter({
    method: "PATCH",
    url: `admin/organizations/${organizationId}`,
    data: body,
  });
  return unwrapEnvelopeValue(envelope);
};

/**
 * @param {string|number} organizationId
 */
export const deactivateOrganization = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "DELETE",
    url: `admin/organizations/${organizationId}`,
  });
  return unwrapEnvelopeValue(envelope);
};

export const fetchOrganizationLogo = async (organizationId) => {
  const response = await axios.get(
    `${getCallCenterBaseUrl()}api/admin/organizations/${organizationId}/logo`,
    {
      responseType: "blob",
      headers: buildAuthHeaders(),
    }
  );
  return response.data;
};

export const uploadOrganizationLogo = async (organizationId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const envelope = await requestCallCenter({
    method: "post",
    url: `admin/organizations/${organizationId}/logo`,
    data: formData,
  });
  return unwrapEnvelopeValue(envelope, "Failed to upload organization logo");
};
